import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tr-nohover" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "d-flex flex-column" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { colspan: "2" }
const _hoisted_11 = { class: "text-black-75" }

import { ref } from "vue";
import {
  SELECT_WORK_EVENT_TYPES
} from "@/services/consts";
import DeliveryPlanEvent from '@/services/models/DeliveryPlanEvent'
import DeliveryPlanEventType from "@/types/DeliveryPlanEvent"
import Workload from '@/services/models/Workload'
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { ja } from 'date-fns/locale'
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'DailyReportWorkListEditRow',
  props: {
  modelValue: {},
  index: { type: Number },
},
  emits: [
  "update:modelValue",
  "remove",
  "save",
],
  setup(__props, { emit: __emit }) {


const props = __props

const emits = __emit;
const errors = ref({});
const beforeItem = structuredClone(props.modelValue);
const stoppingPeriods = ref([]);

const item = ref(props.modelValue);

function remove() {
  emits('remove');
}

function save() {
  if (validate()) {
    item.value.edited_at = new Date().toLocaleTimeString()
    if (item.value.works[0] && item.value.works[1]) {
      Workload.generateWorkId(item.value.delivery_plan_id, item.value.work, true, item.value.start_time)
      .then((digestHex) => {
        item.value.works[0].work_id = digestHex
      });
      Workload.generateWorkId(item.value.delivery_plan_id, item.value.work, false, item.value.end_time)
      .then((digestHex) => {
        item.value.works[1].work_id = digestHex
      });
    }
    item.value.editing = false;
    emits('update:modelValue', item.value);
    emits('save');
  }
}

function undo() {
  Object.assign(item.value, structuredClone(beforeItem));
  item.value.editing = false;
  errors.value = {};
  emits('update:modelValue', item.value);
}

function validate() {
  let isValid = true
  const errs = DeliveryPlanEvent.validate(item.value, beforeItem, stoppingPeriods.value)
  if (errs) {
    isValid = false
  }
  errors.value = errs ?? {}
  return isValid
}

function getSelectableRangeMessage(item: DeliveryPlanEventType) {
  if (item.before_end == item.after_start) {
    return i18n.global.t('pages.dailyReports.updateModal.messages.notChange')
  }
  return i18n.global.t('pages.dailyReports.updateModal.workList.selectableRange') + ': ' +
    item.before_end + '~' + item.after_start
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", _hoisted_1, [
      _createElementVNode("td", null, _toDisplayString(props.index), 1),
      (item.value.work != 'returning_warehouse')
        ? (_openBlock(), _createElementBlock("td", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("select", {
                class: "border work-table-input-box",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.work) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SELECT_WORK_EVENT_TYPES), (value, name) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: 'work_type_' + value,
                    value: name
                  }, _toDisplayString(value), 9, _hoisted_4))
                }), 128))
              ], 512), [
                [_vModelSelect, item.value.work]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value?.work ?? [], (message, i) => {
                return (_openBlock(), _createElementBlock("small", {
                  class: "text-danger",
                  key: 'error-work-'+i
                }, _toDisplayString(message), 1))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("td", _hoisted_5, _toDisplayString(_unref(SELECT_WORK_EVENT_TYPES)[item.value.work]), 1)),
      _createElementVNode("td", null, [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            class: "border work-table-input-box",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.spot_name) = $event))
          }, null, 512), [
            [_vModelText, item.value.spot_name]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value?.spot_name ?? [], (message, i) => {
            return (_openBlock(), _createElementBlock("small", {
              class: "text-danger",
              key: 'error-work-'+i
            }, _toDisplayString(message), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_unref(VueDatePicker), {
          class: "",
          clearable: false,
          modelValue: item.value.start_time,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.start_time) = $event)),
          locale: _unref(ja),
          formats: { input: 'yyyy-MM-dd HH:mm:ss' },
          enableSeconds: true,
          "time-config": { enableSeconds: true }
        }, null, 8, ["modelValue", "locale"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value?.start_time ?? [], (message, i) => {
          return (_openBlock(), _createElementBlock("small", {
            class: "text-danger",
            key: 'error-work-'+i
          }, _toDisplayString(message), 1))
        }), 128))
      ]),
      (item.value.work != 'returning_warehouse')
        ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
            _createVNode(_unref(VueDatePicker), {
              class: "",
              clearable: false,
              modelValue: item.value.end_time,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.end_time) = $event)),
              locale: _unref(ja),
              formats: { input: 'yyyy-MM-dd HH:mm:ss' },
              enableSeconds: true,
              "time-config": { enableSeconds: true }
            }, null, 8, ["modelValue", "locale"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value?.end_time ?? [], (message, i) => {
              return (_openBlock(), _createElementBlock("small", {
                class: "text-danger",
                key: 'error-work-'+i
              }, _toDisplayString(message), 1))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("td", _hoisted_8)),
      _cache[7] || (_cache[7] = _createElementVNode("td", null, null, -1)),
      _cache[8] || (_cache[8] = _createElementVNode("td", null, null, -1)),
      _cache[9] || (_cache[9] = _createElementVNode("td", null, null, -1)),
      _cache[10] || (_cache[10] = _createElementVNode("td", null, null, -1)),
      _cache[11] || (_cache[11] = _createElementVNode("td", null, null, -1)),
      _createElementVNode("td", null, [
        _createElementVNode("button", {
          class: "update-dailyreport-button undo-button",
          onClick: undo
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "material-symbols-outlined" }, " undo ", -1)
        ]))])
      ]),
      _createElementVNode("td", null, [
        _createElementVNode("button", {
          class: "update-dailyreport-button save-button",
          onClick: save
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("span", { class: "material-symbols-outlined" }, " save ", -1)
        ]))]),
        (item.value.work != 'leaving_warehouse' && item.value.adding)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "update-dailyreport-button delete-button",
              onClick: remove
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("span", { class: "material-symbols-outlined" }, " delete ", -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ]),
    (item.value.work == 'returning_warehouse')
      ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
          _cache[12] || (_cache[12] = _createElementVNode("td", null, null, -1)),
          _cache[13] || (_cache[13] = _createElementVNode("td", null, null, -1)),
          _cache[14] || (_cache[14] = _createElementVNode("td", null, null, -1)),
          _createElementVNode("td", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(getSelectableRangeMessage(item.value)), 1)
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("td", null, null, -1)),
          _cache[16] || (_cache[16] = _createElementVNode("td", null, null, -1)),
          _cache[17] || (_cache[17] = _createElementVNode("td", null, null, -1)),
          _cache[18] || (_cache[18] = _createElementVNode("td", null, null, -1)),
          _cache[19] || (_cache[19] = _createElementVNode("td", null, null, -1)),
          _cache[20] || (_cache[20] = _createElementVNode("td", null, null, -1))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})